// admin.guard.ts (functional guard)
import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router, UrlTree } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';

/**
 * Allows only authenticated, authorized administrators. Non-admins are bounced
 * to /releases; unauthenticated/unauthorized users follow the same paths as authGuard.
 */
export const adminGuard = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return toObservable(auth.authCheckedSig).pipe(
    filter(Boolean), // wait until initial auth check completes
    take(1),
    map((): boolean | UrlTree => {
      if (!auth.isAuthenticatedSig()) return router.parseUrl('');
      if (!auth.isAuthorizedSig()) return router.parseUrl('/unauthorized');
      if (!auth.isAdminSig()) return router.parseUrl('/releases');
      return true;
    }),
  );
};
